import { createSlice } from '@reduxjs/toolkit'
import { createActions, arrayToString } from "@helper"
import * as actions from '../action'

const initialState = {
    params: {
	    userCode: '', // 客户编号
	    mobile: '', // 手机号码
	    outerMemberId: '', // 会员编号
	    source: '', // 来源类型
	    media: '', // 来源名称
	    terminalCodeList: [], // 注册应用
	    memberLevelCodeList: [], // 会员等级
	    shopCodeList: [], // 注册店铺
	    registerTime: [] // 注册时间
    },
    page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
    },
    shopCodeList: [],
    terminals: [],
    memberLevelList: [],
    userList: [] // 用户列表
}

const reducers = createActions({
    getUserShopCodeListAction: {
        success: (state, action) => ({
            ...state,
	        shopCodeList: action.payload
        })
    },
    getTerminalAction: {
        success: (state, action) => ({
            ...state,
	        terminals: action.payload
        })
    },
    getMemberLevelListAction: {
        success: (state, action) => ({
            ...state,
	        memberLevelList: action.payload
        })
    },
    getUserListAction: {
        pending: (state, action) => {
            const { meta: { arg: { data } } } = action
            const {
                pageNum,
                pageSize,
                userCode,
                mobile,
                outerMemberId,
                registerStartTime,
                registerEndTime,
                ...otherParams
            } = data
	        const registerTime = registerStartTime ? [registerStartTime, registerEndTime] : []
			
            return {
	            ...state,
	            page: { ...state.page, pageNum, pageSize },
	            params: {
                    ...otherParams,
		            registerTime,
		            userCode: arrayToString(userCode),
		            mobile: arrayToString(mobile),
		            outerMemberId: arrayToString(outerMemberId)
	            }
            }
        },
        success: (state, action) => {
            const { list = [], total, pageNum } = action.payload
			
            return { ...state, pageNum, total, userList: list }
        }
    }
}, actions)

const customerSlice = createSlice({
    name: 'customer',
    initialState,
    ...reducers,
    reducers: {
        resetParams: (state) => ({
            ...state,
	        page: {
                ...state.page,
		        pageNum: 1,
		        pageSize: 10
	        },
            params: {
                userCode: '', // 客户编号
                mobile: '', // 手机号码
                outerMemberId: '', // 会员编号
                source: '', // 来源类型
                media: '', // 来源名称
                terminalCodeList: [], // 注册应用
                memberLevelCodeList: [], // 会员等级
                shopCodeList: [], // 注册店铺
                registerTime: [] // 注册时间
            }
        })
    }
})

export const {
    resetParams
} = customerSlice.actions

export const getParams = state => state.customer.params

export const getPages = state => state.customer.page

export default customerSlice
